import classNames from 'classnames';
import {SvgIcon} from 'components/SvgIcon';
import chevronRightIcon from 'public/icons/chevron-right-24.svg';

import style from './style.module.scss';

const ChevronIcon: FC = ({className}) => <SvgIcon className={className} svg={chevronRightIcon} />;

export const DIYChevronIconItem: FC = ({className}) => <ChevronIcon className={classNames(style.chevron, className)} />;
